import lodash from "lodash";
import { APIError, errorLogger } from "./errorHandlers";

import apiEndpointPaths from "./apiEndpointPaths";
import axios from "axios";
import { generateEntitlementRegistry, generateTokenForNewRestaurantMenu, generateTokenForRetailPax, generateTokenForSalesRegistry } from "./tokenGenerators";
import { generateTokenForRetailPaxLoyality } from "../../WidgetCompoentens/Shaakira/RestaurantWidget/utilities/api/token";

/* 
  Get `Company` details by `Domain`
*/
export async function getCompanyDetailsByDomain(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateTokenForRetailPax();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getCompanyByDomain;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

/* 
  Get Settings By Org ID
*/
export async function getSettingsByOrgId(OrgID) {
  try {

    let token = await generateTokenForSalesRegistry();

    const apiReqUrl = apiEndpointPaths.salesRegistry.getSettingsByOrgId;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: `${apiReqUrl}/${OrgID}/0`,
      headers,
    });


    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}
/* 
  Get All Home Layouts that assigns to a Company ID
*/
export async function getCompanyAllHomeLayouts(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateTokenForRetailPax();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getCompanyAllHomeLayouts;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

/* 
  Get All home Layouts that assigns to a Page ID
*/
export async function getPageHomeLayout(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateTokenForRetailPax();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getPageHomeLayout;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

/* 
  Get Home Layout by ID
*/
export async function getHomeLayoutByID(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateTokenForRetailPax();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getHomeLayoutById;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

/* 
  Get All Pages info that assigns for a Company ID
*/
export async function getCompanyAllPagesInfo(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateTokenForRetailPax();
    console.log(token, "token")
    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getCompanyAllPagesInfo;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

/* 
  Get Pages info by ID
*/
export async function getPageInfoByID(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateTokenForRetailPax();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getPageInfoById;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

/* 
  Get `Tiers details`
*/
export async function getTierDetails(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateEntitlementRegistry();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getTierDetails;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

// Get Vertical List

export async function getVerticalListPlan(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateEntitlementRegistry();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getVerticalPlan;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const resObj = await axios({
      method: "GET",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const Result = resObj.data.Result;
    console.log('Result==>> ', Result)
    return Result;
  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

export async function getFrequencyDetails(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateEntitlementRegistry();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getFrequencyDetails;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}

/* 
  Get Vertical Plan Features
    ex: `Witmeg-Retail`, `Witmeg-Hospitality`
*/
export async function getVerticalPlanFeatures(reqBody = {}, options = {}) {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData };

    let token = await generateEntitlementRegistry();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.getProductFeatures;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}
export async function getPageDetails(id) {
  try {

    let token = await generateTokenForRetailPax();

    const apiReqUrl = `${apiEndpointPaths.witmegRetailPaxServer.getPages}?WebsiteId=${id}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    console.log(error)
  }
}
export async function contactEnquiry(reqBody) {
  try {
    let token = await generateTokenForRetailPax();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.addContact;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: reqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    console.log(error)
  }
}
export async function getHomeBanners(data) {
  try {
    let token = await generateTokenForRetailPaxLoyality();

    const apiReqUrl = apiEndpointPaths.loyaltyRegistryServer.getBanners;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: data,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    console.log(error)
  }
}
export async function bannerClick(id) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const data = {
      "device": window.screen.width < 600 ? "mobile" : "desktop",
    }
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.bannerImpression}/${id}/click`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: data,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    console.log(error)
  }
}
export async function bannerImpression(id) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const data = {
      "device": window.screen.width < 600 ? "mobile" : "desktop",
    }
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.bannerImpression}/${id}/impression`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: data,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    console.log(error)
  }
}
export async function addItemToWishList(data, userId) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.addToWishList}/${userId}/product/wishlist/add`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "PUT",
      url: apiReqUrl,
      data: data,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    console.log(error)
  }
}
export async function getWishlist(locID, userId) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.getWishlistData}/${userId}/store/${locID}/wishlist`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      headers,
    });

    const { Status, Result } = response.data;
    console.log(Status ? Result : [])
    return Status ? Result : [];

  } catch (error) {
    console.log(error)
  }
}
export const getFilterRestaurantMenuData = async (reqBody = {}) => {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData, ApplicationID: "632983961250b0105020d561", Type: "MENU" };
    let token = await generateTokenForNewRestaurantMenu();

    const apiReqUrl = apiEndpointPaths.loyaltyRegistryServer.getAllRestaurantMenuItems;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result, Currency, MenuCreationDate, TotalCount } = response.data;

    return Status ? { data: Result, currency: Currency, menuCreatedDate: MenuCreationDate, total: TotalCount } : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}
export const getFilteredData = async (reqBody = {}) => {
  try {
    const { ...fullReqBodyData } = reqBody;
    const apiReqBody = { ...fullReqBodyData, ApplicationID: "632983961250b0105020d561", Type: "MENU" };
    let token = await generateTokenForNewRestaurantMenu();

    const apiReqUrl = apiEndpointPaths.loyaltyRegistryServer.getFilterMenu;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: apiReqBody,
      headers,
    });

    const { Status, Result, Currency, MenuCreationDate, TotalCount } = response.data;

    return Status ? { data: Result, currency: Currency, menuCreatedDate: MenuCreationDate, total: TotalCount } : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}
export const getPreparationSettings = async (locationID) => {
  try {
    let token = await generateTokenForRetailPaxLoyality();

    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.gerPrepareSettings}/${locationID}/preparation-settings`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    console.log("sdasd")
    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      headers,
    });

    const { Status, Result } = response.data;
    return Status ? Result : null;


  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}
export async function franchiseFormSubmission(reqBody = {}) {
  try {

    let token = await generateTokenForRetailPax();

    const apiReqUrl = apiEndpointPaths.witmegRetailPaxServer.submitForm;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      data: reqBody,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}
export async function getEventsById(eventID) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.getEvent}/${eventID}/get`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      headers,
    });

    const { Status, Result } = response.data;
    return Status ? Result : Result;

  } catch (error) {
    console.log(error)
  }
}
export async function bookEvent(rebody) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.bookEvent}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      headers,
      data: rebody
    });

    const { Status, Data } = response.data;
    return Status ? Data : null;

  } catch (error) {
    console.log(error)
  }
}
export async function processPayment(rebody) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.processPayment}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      headers,
      data: rebody
    });

    const { Status, Data } = response.data;
    return Status ? Data : null;

  } catch (error) {
    console.log(error)
  }
}
export async function getRecommendationItems(data) {
  try {

    let token = await generateTokenForRetailPaxLoyality();

    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.getRecommendationItems}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "POST",
      url: apiReqUrl,
      headers,
      data
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    console.log(error)
  }
}
export async function getMessages(orgID, locID) {
  try {
    let token = await generateTokenForRetailPaxLoyality();
    const apiReqUrl = `${apiEndpointPaths.loyaltyRegistryServer.getMessages}/active?organizationId=${orgID}&cloudLocationId=${locID}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      headers,
    });

    const { Status, Result } = response.data;
    return Status ? Result : Result;

  } catch (error) {
    console.log(error)
  }
}
/* 
  Get All Blogs
*/
export async function getAllBlogPosts(id) {
  try {

    let token = await generateTokenForRetailPax();

    const apiReqUrl = `${apiEndpointPaths.witmegRetailPaxServer.getAllBlogPosts}?website_id=${id}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}
export async function getBlogPost(slug, id) {
  try {

    let token = await generateTokenForRetailPax();

    const apiReqUrl = `${apiEndpointPaths.witmegRetailPaxServer.getAllBlogPosts}/${slug}?website_id=${id}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    const response = await axios({
      method: "GET",
      url: apiReqUrl,
      headers,
    });

    const { Status, Result } = response.data;

    return Status ? Result : null;

  } catch (error) {
    let customErrMsg = error.customErrMsg || "";
    if (error.custmErrType === "APIERROR") {
      switch (true) {
        default: {
          customErrMsg = "Error Occurred. Please try again.";
          break;
        }
      }
    }
    errorLogger(error, { customErrMsg });
    return Promise.reject(APIError(customErrMsg, error));
  }
}